import React, { useEffect, useState } from 'react';
import request from '../../../../utils/request';
import EmployeeListItem from './EmployeeListItem';
import { Typography } from '@mui/material';
import SummaryViewBox from 'src/pages/Rfq/rfqForm/SummaryViewV2/SummaryViewBox';
import GmcTemplate from 'src/pages/Rfq/rfqForm/SummaryViewV2/templates/GmcTemplate/GmcTemplate';
import { useSelector } from 'react-redux';
import { selectDataListSectionIds } from 'src/features/rfqDataSlice';
import ClauseAndCoverageAfterSI from '../clauseAndCoverageAfterSI';
import SuminsuredListHeaderDetails from 'src/pages/Rfq/rfqViewBoxV2/SumInsuredItems/SuminsuredListHeaderDetails';

function EmployeeList({
  rfqId,
  sectionId,
  sumInsuredData,
  showDataList = false,
  usedfrom = null,
  rfqDetails = null,
  placementSlip = false,
  type = null, policyDetail = null, qcRemarkOfEachSections = null, checkAllModuleIsVerified = null,
  setQcRemarkOfEachSections = null,
  EndorsementCompareQcRemarks=null
  
}) {
  const [employeeGroups, setEmployeeGroups] = useState([]);

  useEffect(() => {
    fetchEmpGroups();
  }, []);

  const fetchEmpGroups = () => {
    request({
      url: 'rfq/getRFQListGroups',
      method: 'post',
      data: {
        rfqId: rfqId,
        rfqSectionId: sectionId
      }
    }).then(
      (response: any) => {
        setEmployeeGroups(response.data);
        if (response.data.length > 0) {
          let sumInsuredBox = document.getElementById('sumInsuredBox');
          if (sumInsuredBox) {
            sumInsuredBox.style.display = 'block';
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };
  const showSectionDataList = useSelector(selectDataListSectionIds);
  return (
    <>
      {/* Check conditions for showing section name */}
      {employeeGroups.length > 0 &&
        !sumInsuredData?.summaryViewStructure &&
        (showDataList ? showSectionDataList.includes(sectionId) : true) && (
          <Typography
            gutterBottom
            variant="h5"
            className="heading"
            component="div"
            style={{
              marginTop: '10px',
              marginBlock: '5px',
              fontWeight: 'bold!important',
              padding: '6px',
              background: 'rgb(9, 84, 174)',
              color: '#fff',
              textAlign: 'center'
            }}
          >
            {sumInsuredData?.sectionName}
          </Typography>
        )}

      {/* Show AssetListItem only if showDataList is true */}
      {showDataList &&
        showSectionDataList.includes(sectionId) &&
        employeeGroups.length > 0 &&
        employeeGroups.map((group) => (
          <EmployeeListItem
            key={group.id}
            sumInsuredData={sumInsuredData}
            groupDetails={group}
            rfqId={rfqId}
            type={type}
            policyDetail={policyDetail}
            qcRemarkOfEachSections={qcRemarkOfEachSections}
            checkAllModuleIsVerified={checkAllModuleIsVerified}
            setQcRemarkOfEachSections={setQcRemarkOfEachSections}
            EndorsementCompareQcRemarks={EndorsementCompareQcRemarks}
          />
        ))}

      {!showDataList && (
        <>
          {' '}
          {sumInsuredData?.summaryViewStructure ? (
            sumInsuredData?.summaryViewStructure?.type === 'GMC' ? (
              <GmcTemplate
                warning={false}
                summaryStructureData={sumInsuredData?.summaryViewStructure}
                rfqSectionId={sectionId}
                usedfrom={usedfrom}
                isFromView={true}
              />
            ) : (
              <SummaryViewBox
                isFromView={true}
                sectionId={sectionId}
                time=""
                closeForm={() => { }}
                reGenerate={() => { }}
                summaryViewData={sumInsuredData?.summaryViewStructure?.summary}
                summaryStructureData={sumInsuredData?.summaryViewStructure}
              />
            )
          ) : (
            employeeGroups.length > 0 &&
            employeeGroups.map((group) => (
              <EmployeeListItem
                key={group.id}
                sumInsuredData={sumInsuredData}
                groupDetails={group}
                rfqId={rfqId}
                type={type}
                policyDetail={policyDetail}
                qcRemarkOfEachSections={qcRemarkOfEachSections}
                checkAllModuleIsVerified={checkAllModuleIsVerified}
                setQcRemarkOfEachSections={setQcRemarkOfEachSections}
              />
            ))
          )}
          {rfqDetails &&
            (rfqDetails['clauseAndCovPosition'] == 'Below-SI' ||
              rfqDetails['clauseAndCovPosition'] == 'Cov-below-SI') &&
            !placementSlip && (
              <ClauseAndCoverageAfterSI
                rfqDetails={rfqDetails}
                rfqId={rfqId}
                sectionId={sectionId}
              />
            )}

          {sumInsuredData?.totalSumInsured &&  <SuminsuredListHeaderDetails sumInsuredData={sumInsuredData}/>}

        </>
      )}
    </>
  );
}

export default EmployeeList;
